export default {
  title: 'yellow',

  colors: {
    twitter: 'rgb(221, 162, 73)',
    darkhover: '#1A1205',
    lighthover: '#332E24',
  },
};